import React, { useState, useEffect } from 'react';
import { Route, Switch, useLocation } from 'wouter';
import LessonPlanManagerDevelopment from './LessonPlanManagerDevelopment';
import LessonPlanWizardDevelopment from './LessonPlanWizardDevelopment';
import * as lessonPlanApi from './services/lessonPlanApi';
import CircularLoader from "@common/CircularLoader";
import InteractiveLessonPlanDevelopment from "./InteractiveLessonPlanDevelopment";

// Redirect component for catch-all route
const RedirectToBase = ({ baseUrl }) => {
    const [, setLocation] = useLocation();
    useEffect(() => {
        setLocation(baseUrl);
    }, [baseUrl, setLocation]);
    return null;
};

const LessonPlans = () => {
    const BASE_URL = '/web/ui/view/lessonPlans';

    const [wizardConfig, setWizardConfig] = useState(null);
    const [curriculumData, setCurriculumData] = useState(null);
    const [instructionalBlocks, setInstructionalBlocks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            setIsLoading(true);
            try {
                const [configResponse, curriculumResponse, blocksResponse] = await Promise.all([
                    lessonPlanApi.getWizardConfig(),
                    lessonPlanApi.getCurriculumData(),
                    lessonPlanApi.getInstructionalBlocks()
                ]);
                setWizardConfig(configResponse);
                setCurriculumData(curriculumResponse);
                setInstructionalBlocks(blocksResponse);
            } catch (error) {
                console.error('Failed to load lesson plan data:', error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    if (isLoading) {
        return <CircularLoader />;
    }

    return (
        <div className="ch-lesson-plans">
            <Switch>
                <Route path={`${BASE_URL}/createLessonPlan`}>
                    <LessonPlanWizardDevelopment
                        wizardConfig={wizardConfig}
                        curriculumData={curriculumData}
                        instructionalBlocks={instructionalBlocks}
                        onClose={() => window.location.href = BASE_URL}
                    />
                </Route>
                <Route path={`${BASE_URL}/plans/:planId`}>
                    <InteractiveLessonPlanDevelopment />
                </Route>
                <Route path={`${BASE_URL}`}>
                    <LessonPlanManagerDevelopment />
                </Route>
                {/* Catch-all: redirect any unmatched route to base */}
                <Route path={`${BASE_URL}/:rest*`}>
                    <RedirectToBase baseUrl={BASE_URL} />
                </Route>
            </Switch>
        </div>
    );
};

export default LessonPlans;
